module.exports = __webpack_public_path__ + "img/payments-way.37d4a2ab.png";